var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('PromotionsComponent',{attrs:{"promotions":_vm.promotion.promotions,"loading":_vm.promotion.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }